import { LandingpageLowerArrowContainer, LandingpageRightArrowContainer, LandingpageUpperArrowContainer } from "../../assets/ts/pages/landingpage";
import { ReactComponent as LowerArrow } from '../../assets/content/landingpage-arrow-lower.svg';
import { ReactComponent as UpperArrow } from '../../assets/content/landingpage-arrow-upper.svg';
import { ReactComponent as RightArrow } from '../../assets/content/landingpage-arrow-right.svg';

export function LandingpageArrow ({
    type,
}: {
    type: 'upper' | 'lower' | 'right';
}) {

    switch (type) {
        case "upper":
            return (
                <LandingpageUpperArrowContainer>
                    <UpperArrow />
                </LandingpageUpperArrowContainer>
            );
        case "lower":
            return (
                <LandingpageLowerArrowContainer>
                    <LowerArrow />
                </LandingpageLowerArrowContainer>
            );
        case "right":
            return (
                <LandingpageRightArrowContainer>
                    <RightArrow />
                </LandingpageRightArrowContainer>
            );
    }
}